import { render, staticRenderFns } from "./Traceability.vue?vue&type=template&id=ac73412e&scoped=true"
import script from "./Traceability.vue?vue&type=script&lang=js"
export * from "./Traceability.vue?vue&type=script&lang=js"
import style0 from "./Traceability.vue?vue&type=style&index=0&id=ac73412e&prod&scoped=scoped&lang=less"
import style1 from "./Traceability.vue?vue&type=style&index=1&id=ac73412e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac73412e",
  null
  
)

export default component.exports